import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) return children;

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Flex direction="column" gap={16}>
        <Skeleton height="24px" width="260px" />
        <Skeleton height="34px" width="100%" />
      </UiKit.Flex>
    </SkeletonTheme>
  );
}
